
export interface RouteProps {
    lang: 'cs' | 'en';
}

export default "/:lang";